module.exports = ".subnav ul {\n  padding: 0;\n  margin: 0;\n  list-style: none; }\n\n.subnav {\n  background: #003277;\n  padding: 0px 15px 20px 15px; }\n\n@media screen and (min-width: 600px) {\n    .subnav {\n      padding: 0px 30px 20px 30px; } }\n\n.subnav ul li {\n    display: inline-block;\n    padding-right: 30px; }\n\n.subnav a {\n    color: rgba(255, 255, 255, 0.62); }\n\n.subnav a.active {\n      color: white;\n      font-weight: bold; }\n\n.subnav a:hover {\n      color: white; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/subnav/subnav.component.scss
// module id = ./src/app/components/subnav/subnav.component.scss
// module chunks = main